import React from 'react';
import AboutUsBanner from './AboutUsBanner';

const AboutUs = () => (
	<div>
		<AboutUsBanner />
	</div>
);

export default AboutUs;
